module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    class: _vm.classes
  }, [_c('div', {
    class: _vm.mainClasses
  }, [_c('span', {
    class: _vm.dotClasses
  }), _vm._v(" "), _c('div', {
    class: _vm.textClasses
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bb5aceb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/spin/spin.vue
// module id = 639
// module chunks = 1